import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router/router'
import store from './store/index'
import messages from './locale/index'
import foot from '@/components/footer'
import './styles/index.scss'

Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.component('foot', foot)
const i18n = new VueI18n({ locale: 'zh', fallbackLocale: 'zh', messages })
new Vue({ el: '#app', i18n, router, store, render: h => h(App) })



// WEBPACK FOOTER //
// ./src/main.js